import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import System from "../../../helper/system";
import { useBOMStore } from 'src/hooks/bom';
import { useBOMProjectStore } from '../../../hooks/bom_project';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const BomDeletePopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [status, SetStatus] = useState(false);
    const [{ BomDeletePopup }, {}, {}] = useDOMAttachToSystemStore();
    const [{ }, { }, { delete_bom_by_bom_id }] = useBOMStore();
    const [{ }, { fetch_bom_project_detail_with_bom }] = useBOMProjectStore();
    useEffect(() => {
        if (BomDeletePopup) {
            SetStatus(true)
        }
    }, [BomDeletePopup]);
    const onHide = (action = true) => {
        SetStatus(false)
    };
    const onDeleteBom = async () => {
        let bomId = BomDeletePopup && BomDeletePopup.data && BomDeletePopup.data.single_bom && BomDeletePopup.data.single_bom.bomId
        await delete_bom_by_bom_id({ bomId });
        onHide()
        await fetch_bom_project_detail_with_bom()
        System.alert('Your BOM ' + `${BomDeletePopup && BomDeletePopup.data && BomDeletePopup.data.single_bom && BomDeletePopup.data.single_bom.bomName}` + ' has been deleted');
    };

    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>

                <div className="avnet-modal modal-730">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header border-0">
                            <h3 className="modal-title text-center m-auto" id="exampleModalLabel">Are you sure you want to
                                delete this BOM?</h3>
                        </div>

                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary w145"
                                onClick={() => {
                                    onHide()
                                }}>cancel
                            </button>
                            <button type="button" className="bs5 btn btn-primary  w145"
                                onClick={(e) => { __check(['BOM_PROJECT_API_CALL', 'BOM_OPERATION_API_CALL']).status ? e.preventDefault() : onDeleteBom() }}>
                                {__check(['BOM_PROJECT_API_CALL', 'BOM_OPERATION_API_CALL']).status &&
                                    <>
                                        <i className="fa fa-spinner fa-spin" />
                                    </>
                                }
                                {!__check(['BOM_PROJECT_API_CALL', 'BOM_OPERATION_API_CALL']).status &&
                                    <>
                                        delete bom
                                    </>
                                }
                            </button>

                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default BomDeletePopup;